//types
export enum ActionType {
  ADD_CART_ITEM = 'ADD_CART_ITEM',
  REMOVE_CART_ITEM = 'REMOVE_CART_ITEM',
  REDUCE_CART_ITEM = 'REDUCE_CART_ITEM',
  CLEAR_CART = 'CLEAR_CART',
}
